var btnLoading = {
  "animSpinnerIndeterminate": {
    "willChange": "transform",
    "WebkitAnimation": "spinner-indeterminate 0.8S linear infinite",
    "animation": "spinner-indeterminate 0.8S linear infinite"
  },
  "btnLoading": {
    "&::before": {
      "willChange": "transform",
      "WebkitAnimation": "spinner-indeterminate 0.8S linear infinite",
      "animation": "spinner-indeterminate 0.8S linear infinite",
      "borderStyle": "solid",
      "borderWidth": "2px",
      "borderRadius": "50%",
      "bottom": "0",
      "content": "\"\"",
      "display": "block",
      "height": "22px",
      "left": "0",
      "margin": "auto",
      "position": "absolute",
      "right": "0",
      "top": "0",
      "transform": "translateZ(0)",
      "width": "22px"
    },
    "overflow": "hidden"
  },
  "keyframesSpinnerIndeterminate": {
    "@keyframes spinner-indeterminate": {
      "0%": {
        "transform": "rotate(0deg)"
      },
      "100%": {
        "transform": "rotate(360deg)"
      }
    }
  },
  "btnPrimary_btnLoading": {
    "&::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#fff",
      "borderStyle": "solid"
    }
  },
  "btnSecondary_btnLoading": {
    "&::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#006fcf",
      "borderStyle": "solid"
    }
  },
  "btnTertiary_btnLoading": {
    "&::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#006fcf",
      "borderStyle": "solid"
    }
  },
  "btnContextual_btnLoading": {
    "&::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#006fcf",
      "borderStyle": "solid"
    }
  },
  "btnWhite": {
    "&:not(.btnContextual).btnLoading::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#006fcf",
      "borderStyle": "solid"
    }
  },
  "btnWhiteSecondary_btnLoading": {
    "&::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#006fcf",
      "borderStyle": "solid"
    }
  },
  "btnWhiteTertiary_btnLoading": {
    "&::before": {
      "borderColor": "rgba(200, 201, 199, 0.25)",
      "borderLeftColor": "#006fcf",
      "borderStyle": "solid"
    }
  }
};

export default btnLoading;
